import React, { useState } from "react";
import styled from "styled-components";
import anime from "animejs/lib/anime.es.js";
import ReactDOM from "react-dom";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import BackIcon from "../../assets/back-icon.svg";
// import * as Sentry from "@sentry/browser";

import config from "../../config";
import locale from "../../utilities/locale";

import Button from "../../base-components/button";
import classes from "./index.module.css";
import BrightLogo from "../../assets/bright_logo.svg";
import TextInput from "../../base-components/text-input";
import { isValidPhoneNumber } from "../../utilities/Helpers";
import OtpInput from "../../base-components/otp-input";
import {
  openName,
  openShowHoldings,
  openAccountOpenWait,
  openKycFail,
  openBuyWait,
  openAccountOpenSuccess,
  open500ErrorPage,
} from "../../navigators/routes";
import { setIsLogin, setUserCurrentScreen } from "../../redux/action/app";
import { dashboard, login } from "../../redux/thunk/app.thunk";
import { AccountStatus, DashboardAction } from "../../utilities/Variables";
import { ErrorLabel, FireBase } from "./utils";

const LoginComponent = (props) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const userOnDashboard = useSelector((state) => state.app.userOnDashboard);

  const [phone, setPhone] = useState("");
  const [otpScreen, setOtpScreen] = useState(false);
  const [resendCountdown, setResendCountdown] = useState(0);
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [confirmResult, setConfirmResult] = useState(null);
  const [MaskedPhoneNumber, setMaskedPhoneNumber] = useState(null);
  const [loading, setLoading] = useState(null);

  const [timer, setTimer] = useState(null);

  const validation = React.useRef(null);
  const OTPinput = React.useRef(null);
  const Phoneinput = React.useRef(null);
  const initialRender = React.useRef(true);

  React.useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      FireBase();
    } else {
      if (otp.toString().length === 6) {
        onSubmit();
      }
    }
  }, [otp, phone]);

  const getFormattedPhoneNumber = (num) => {
    if (num) {
      const parts = [num.slice(0, 3), num.slice(3, 6), num.slice(6, 10)];
      let fNum = parts[0];
      if (num.length > 3) fNum = fNum + "-" + parts[1];
      if (num.length > 6) fNum = fNum + "-" + parts[2];
      return fNum;
    }
    return num;
  };

  const getFormattedPhoneNumberWoCode = (phone) => {
    return (
      (phone &&
        getFormattedPhoneNumber(phone.slice(config.app.phonePrefix.length))) ||
      ""
    );
  };

  const onLoginOrRegister = async (phNumber) => {
    console.log("Phone inputted", phNumber);
    var appVerifier = window.recaptchaVerifier;

    // appVerifier.verify();
    if (phNumber) {
      // if (!isOTPFlow) {
      //   manualPhoneEntered(phNumber);
      // }
      firebase
        .auth()
        .signInWithPhoneNumber(phNumber, appVerifier)
        .then((confirmResult) => {
          setConfirmResult(confirmResult);
          setOtpScreen(true);
          setLoading(false);
          console.log("hey dude", confirmResult);
          anime({
            targets: ReactDOM.findDOMNode(OTPinput.current),
            translateX: [100, 0],
            translateY: [0, -50],
            opacity: [0, 1],
            easing: "easeInOutExpo",
            duration: 1000,
          });
          anime({
            targets: ReactDOM.findDOMNode(Phoneinput.current),
            translateX: [0, 100],
            opacity: [1, 0],
            easing: "easeInOutExpo",
            duration: 1000,
          });
        })
        .catch((error) => {
          const { code, message } = error;
          console.log("error: ", message);
          setLoading(false);
          setIsError(true);
          setErrorMsg("Please enter valid phone number");
          changeNumberClick(true);
        });
    } else {
    }
  };
  const onVerificationCode = async (code) => {
    setLoading(true);
    if (confirmResult) {
      confirmResult
        .confirm(code)
        .then(async (user) => {
          console.log("if this then success, firebase user: ", user);
          const userObj = user.user;

          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then(async (idToken) => {
              console.log(idToken);
              //login api called

              dispatch(
                login({
                  phoneNumber: MaskedPhoneNumber,
                  phoneUId: userObj.uid,
                  idToken: idToken,
                })
              ).then((loginReponse) => {
                console.log(loginReponse);
                //dashboard api called

                dispatch(
                  dashboard({
                    action: DashboardAction.CheckStatus,
                  })
                ).then((response) => {
                  //dashboard api response
                  const accountStatus = response?.account_status;
                  if (
                    accountStatus === AccountStatus.PortfolioCreated ||
                    accountStatus === AccountStatus.WithdrawPending ||
                    accountStatus === AccountStatus.WithdrawPartialSuccess ||
                    accountStatus === AccountStatus.WithdrawSuccessful
                  ) {
                    dispatch(setUserCurrentScreen(config.routes.showHoldings));
                    openShowHoldings();
                  } else if (accountStatus === AccountStatus.KycPeding) {
                    dispatch(
                      setUserCurrentScreen(config.routes.accountOpenWait)
                    );
                    openAccountOpenWait();
                  } else if (accountStatus === AccountStatus.KycFail) {
                    dispatch(setUserCurrentScreen(config.routes.kycFail));
                    openKycFail();
                  } else if (
                    accountStatus === AccountStatus.PurchasePending ||
                    accountStatus === AccountStatus.PurchasePartialSuccess
                  ) {
                    dispatch(setUserCurrentScreen(config.routes.buyWait));
                    openBuyWait();
                  } else if (accountStatus === AccountStatus.AccountOpened) {
                    dispatch(
                      setUserCurrentScreen(config.routes.accountOpenSuccess)
                    );
                    openAccountOpenSuccess();
                  } else if (response?.is_onboarded == false) {
                    dispatch(setUserCurrentScreen(config.routes.name));
                    openName();
                  }
                })
              });
            })
            .catch((error) => {
              const { code, message } = error;
              console.log("error: ", message);
              setLoading(false);
              setIsError(true);
              setErrorMsg("Oops, something went wrong. Please try again");
              changeNumberClick(true);
              return;
            });
        })
        .catch((error) => {
          const { code, message } = error;
          console.log("error: ", message);
          setOtpError(true);
          setOtp("");
          setLoading(false);
        });
    } else {
      onLoginOrRegister(phone);
    }
  };

  const decrementTimeRemaining = () => {
    if (resendCountdown > 0) {
      setResendCountdown(resendCountdown - 1);
    } else {
      timer && clearInterval(timer);
    }
  };

  const sendOtp = () => {
    onLoginOrRegister(
      config.app.phonePrefix +
        MaskedPhoneNumber.replace(/[^\d]/g, "").replace(/-/g, "")
    );
  };

  const onSubmit = () => {
    setIsError(false);
    setErrorMsg(null);
    setLoading(true);
    if (otpScreen) {
      if (otp.length === 6 && !isNaN(otp)) {
        console.log("trying the otp one");
        onVerificationCode(otp);
      } else if (otp.length < 6 || isNaN(otp)) {
        setOtpError(true);
        setLoading(false);
      }
    } else if (MaskedPhoneNumber && MaskedPhoneNumber.length == 12) {
      console.log("trying the phone number one", MaskedPhoneNumber);
      sendOtp();
    }
  };

  const changeNumberClick = (resetOnly = false) => {
    // !resetOnly && this.props.clickChangeNumber();
    setPhone("");
    setOtp("");
    setOtpScreen(false);
    anime({
      targets: ReactDOM.findDOMNode(OTPinput.current),
      translateX: [1000, 0],
      opacity: [1, 0],
      delay: 400,
    });
    anime({
      targets: ReactDOM.findDOMNode(Phoneinput.current),
      translateX: [1000, 0],
      opacity: [0, 1],
      delay: 400,
    });
  };

  const showErrorMessage = !isValidPhoneNumber(
    getFormattedPhoneNumberWoCode(phone)
  );

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {otpScreen && (
            <Link to={config.routes.name}>
              <img src={BackIcon} alt="back-icon" />
            </Link>
          )}
          <h2
            className={classes.Heading}
            style={{
              marginRight: otpScreen && "8vh",
              marginLeft: otpScreen && "5vh",
            }}
          >
            {locale.LOGIN_HEADING}
          </h2>
        </div>
        <p className={classes.SubHeading}>
          {!otpScreen ? locale.LOGIN_SUBHEADING_2 : locale.OTP_SUBHEADING_2}
        </p>

        <p className={classes.SubHeading}>
          {!otpScreen
            ? locale.LOGIN_SUBHEADING
            : locale.OTP_SUBHEADING(
                getFormattedPhoneNumberWoCode(phone) || MaskedPhoneNumber
              )}
        </p>
      </div>
      <div className={classes.middle}>
        <div className={classes.textInput} ref={Phoneinput}>
          <TextInput
            format="basic"
            pattern={"[0-9]*"}
            label="Phone Number"
            placeholder="Phone Number"
            // prefix="+1"
            onBlur={() => {}}
            onFocus={() => {
              setIsError(false);
            }}
            onChange={(e) => {
              // onChange(e);
              const num = e.target.value
                .replace(/[^\d]/g, "")
                .replace(/-/g, "");
              console.log("HELLO HI", e.target.value);
              e.target.value = getFormattedPhoneNumber(num);
              setMaskedPhoneNumber(e.target.value);
              setPhone(config.app.phonePrefix + num);
              setIsError(false);
            }}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                !loading && onSubmit();
              }
            }}
            maxLength="12"
            showError={isError}
            errorMessage={errorMsg}
            type="tel"
          />
        </div>
        <div className={classes.otpTextInput} ref={OTPinput}>
          <OtpInput
            id="example-3"
            label="label"
            autoFocus
            type="number"
            max="999999"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="6"
            onBlur={() => {}}
            numInputs={6}
            isInputNum
            separator={<span></span>}
            onChange={(otp) => {
              console.log(otp);
              setOtp(otp);
              setOtpError(false);
            }}
            value={otp}
            inputStyle={classes.inputStyle}
          />
          {otpError && <ErrorLabel>{locale.OTP_ERROR}</ErrorLabel>}
        </div>
        {!otpScreen && (
          <p className={classes.details}>{locale.LOGIN_DETAILS}</p>
        )}
      </div>
      <div className={classes.bottom}>
        <Button
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={loading}
          state={undefined}
          action={() => {
            setIsError(showErrorMessage);
            if (showErrorMessage) {
              setErrorMsg(locale.LOGIN_ERROR);
            }
            !showErrorMessage && !loading && onSubmit();
          }}
        >
          {locale.LOGIN_GET_STARTED}
        </Button>
      </div>
      <div
        id="recaptcha-container"
        style={{ display: "none", visibility: "hidden" }}
      ></div>
    </div>
  );
};

export default LoginComponent;
